module.exports = {
          srcSet: __webpack_public_path__ + "88d13e8140d8b79392c426f6053e6379-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "88d13e8140d8b79392c426f6053e6379-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "88d13e8140d8b79392c426f6053e6379-66.jpg",
          toString:function(){return __webpack_public_path__ + "88d13e8140d8b79392c426f6053e6379-66.jpg"},
          
          width: 66,
          height: 66
        }